import React from 'react';

class WebNav extends React.Component {
  componentDidMount() {
    const { secondaryNavData } = this.props;

    const applyRedesignSignal = () => {
      const hudlLayout = document.querySelector('hudl-layout');
      if (!hudlLayout || !hudlLayout.shadowRoot) return false;
      if (!hudlLayout.shadowRoot.querySelector('.global-navigation-layout-card')) return false;
      document.documentElement.classList.add('has-redesign-nav');
      document.body.classList.add('has-redesign-nav');
      return true;
    };

    const watchForRedesign = () => {
      if (applyRedesignSignal()) return;
      const hudlLayout = document.querySelector('hudl-layout');
      if (!hudlLayout || !hudlLayout.shadowRoot) return;
      const observer = new MutationObserver(() => {
        if (applyRedesignSignal()) observer.disconnect();
      });
      observer.observe(hudlLayout.shadowRoot, { childList: true, subtree: true });
    };

    if (customElements.get('hudl-layout')) {
      watchForRedesign();
    } else {
      customElements.whenDefined('hudl-layout').then(watchForRedesign);
    }

    if (secondaryNavData) {
      const setNav = () => {
        const navEl = document.querySelector('hudl-layout');
        if (navEl) navEl.secondaryNavData = secondaryNavData;
      };
      if (customElements.get('hudl-layout')) {
        setNav();
      } else {
        customElements.whenDefined('hudl-layout').then(setNav);
      }
    }
  }

  render() {
    return (
      <div className="prof-flex-container">
        {this.props.children}
      </div>
    );
  }
}

WebNav.propTypes = {
  children: React.PropTypes.element,
  secondaryNavData: React.PropTypes.object,
};

export default WebNav;
